<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1350px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
        >
          mdi-eye
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Task"
      text="View Task"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <!-- TASK -->
          <v-col
            cols="7"
            class="pl-5 pr-5"
          >
            <div class="align-header-switch">
              <span class="font-weight-bold header">
                Task
              </span>
              <v-spacer />
              <v-switch
                v-model="approvalTab"
                inset
                class="pt-0 mt-0 margin-auto"
                label="Action Tab"
              />
            </div>

            <div 
              :id="task.task_scroll_id"
              class="pl-4 pr-6 overflow"
            >
              <v-row>
                <div
                  class="task-content content-pre-line"
                  v-html="formatContent(task.task.content)"
                />
              </v-row>
              <v-row class="mt-2">
                <div class="task-details">
                  <v-row>
                    <v-col
                      cols="6"
                      class="pt-0"
                    >
                      <span class="font-weight-bold"> Task Priority:</span> {{ task.task.priority.name }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pt-0"
                    >
                      <span class="font-weight-bold"> Task Category: </span>{{ task.task.task_category.name }}
                    </v-col>
                  </v-row> 
                  <v-row>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <span class="font-weight-bold"> Task Owner:</span> {{ task.task.owner.person.name }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <span class="font-weight-bold"> Status:</span>
                      <span
                        :class="{ 
                          'warning--text': task.task_status.id === 100,
                          'green--text': task.task_status.id === 199,
                          'black--text': task.task_status.id === 200,
                          'red--text':task.task_status.id === 501
                        }"
                      > {{ task.task_status.name }}</span>
                    </v-col>
                  </v-row> 
                  <v-row>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Created Date:</span> {{ $moment(task.task.created_at).format('DD MMM YYYY') }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Due Date:</span> {{ $moment(task.task.due_date).format('DD MMM YYYY') }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Assignee(s):</span> {{ task.assignee_names }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold"> Viewer(s):</span> {{ task.viewer_names }}
                    </v-col>
                  </v-row>
                </div>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="font-weight-bold px-0 pb-0"
                >
                  ATTACHMENTS
                </v-col>
              </v-row>
              <div class="px-3">
                <v-row>
                  <v-col
                    v-for="document in task.task.documents"
                    :key="document.id"
                    class="px-0 pb-0"
                    cols="2"
                  >
                    <v-card
                      class="mx-2 mb-2"
                      height="120"
                      width="100"
                      target="_blank"
                      :href="document.file_url"
                    >
                      <div class="file-display">
                        <v-icon
                          v-if="document.file_url.split('.').pop()==='pdf'"
                          color="red"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-pdf'"
                        />

                        <v-icon
                          v-else-if="document.file_url.split('.').pop()==='xlsx'"
                          color="green"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-excel'"
                        />

                        <v-icon
                          v-else-if="document.file_url.split('.').pop()==='docx'"
                          color="blue"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-document'"
                        />

                        <v-img
                          v-else-if="['png','jpeg','jpg'].includes(document.file_url.split('.').pop())"
                          width="80"
                          height="80"
                          :src="document.file_url"
                        />
                      </div>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <p
                            class="text-center font-weight-bold long-and-truncated px-1"
                            v-on="{ ...tooltip }"
                          >
                            {{ document.file_name }}
                          </p> 
                        </template>
                        <span>{{ document.file_name }}</span>
                      </v-tooltip>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col
                  cols="12"
                  class="font-weight-bold px-0 pb-0"
                >
                  RATINGS
                </v-col>
              </v-row>
              <div class="px-3 ">
                <v-row
                  v-for="assignee in task.task.assignees"
                  :key="assignee.id"
                  class="rating"
                >
                  <v-row class="font-weight-bold mt-2 ellipsis-assignee">
                    <v-col
                      cols="3"
                      class="pa-0 pl-3 margin-auto"
                    >
                      {{ assignee.employee.person.name }}
                    </v-col>
                    <v-col
                      cols="9"
                      class="pa-0"
                    >
                      <v-rating
                        readonly
                        :value="parseFloat(assignee.rating)"
                        half-increments
                        medium
                        background-color="pink lighten-3"
                        color="pink"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </div>
            </div>
          </v-col>

          <!-- Approval History -->
          <v-col 
            v-show="approvalTab"
            cols="5"
            class="pl-5 pr-5 divider"
          >
            <h4 class="font-weight-bold">
              Approval History
            </h4>
            <div
              v-if="task.task.approval_request.approvals.length>0"
              :id="task.approval_scroll_id"
              class="approval-comment-content" 
            >
              <v-row
                v-for="approval in task.task.approval_request.approvals "
                :key="approval.id"
                no-gutters
              >
                <v-col cols="12">
                  <v-list
                    three-line
                    class="py-0"
                  >
                    <v-list-item>
                      <v-list-item-avatar size="55">
                        <v-img :src="approval.approver.thumbnail_url" />
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="body-1">
                          {{ approval.created_by }} 
                        </v-list-item-title>

                        <v-list-item-subtitle class="body-2">
                          {{ $moment(approval.created_at).format('D MMMM YYYY') }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle style=" -webkit-line-clamp: unset !important;">
                          Remark: {{ approval.remark }} 
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col> 
              </v-row>
            </div> 
            <div
              v-else
              class="approval-comment-content"
            >
              No Approval History
            </div>
          </v-col>

          <!-- Comments -->
          <v-col 
            v-show="!approvalTab"
            class="pl-5 pr-5 divider"
            cols="5"
          >
            <h4 class="font-weight-bold">
              Comments
            </h4>
            <div
              v-if="task.task.task_comments.length>0"
              :id="task.comment_scroll_id"
              class="approval-comment-content"
            >
              <v-row
                v-for="comment in task.task.task_comments "
                :key="comment.id"
                no-gutters
                class="my-2 mx-4"
              >
                <div
                  v-if="task.assignee_uid === comment.commentator_uid"
                  class="pa-2 comment-box-left"
                >
                  <v-col
                    cols="12"
                    class="justify-content pa-0 content-pre-line"
                    v-html="formatContent(comment.comment )"
                  />
                  <v-col
                    cols="12"
                    class="align-right pa-0"
                  >
                    <i>
                      {{ $moment(comment.created_at).format('DD MMM YYYY') }} - <span class="font-weight-bold"> {{ comment.employee.person.name }} </span>
                    </i>
                  </v-col>
                </div>
                <div
                  v-else
                  class="pa-2 comment-box-right"
                >
                  <v-col
                    cols="12"
                    class="justify-content pa-0 content-pre-line"
                    v-html="formatContent(comment.comment )"
                  />
                  <v-col
                    cols="12"
                    class="align-left pa-0"
                  >
                    <i>
                      <span class="font-weight-bold"> {{ comment.employee.person.name }} </span> - {{ $moment(comment.created_at).format('DD MMM YYYY') }}
                    </i>
                  </v-col>
                </div>
              </v-row>
            </div>
            <div
              v-else
              class="approval-comment-content"
            >
              No Comments
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>  
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      task: {
        type: Object,
        default: null,
      },

    },
    data () {
      return {
        dialog: false,
        progressing: false,
        approvalTab: false,
      }
    },
    
    watch: {
      dialog (value) {
        if (value) {
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      },

      approvalTab (value) {
        if (this.dialog) {
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      },
    },

    methods: {
      scrollBottom () {
        // comment section
        if (this.task.task.task_comments.length > 0) {
          let comment = document.getElementById(this.task.comment_scroll_id)
          comment.scrollTop = comment.scrollHeight
        }

        // approval history
        if (this.task.task.approval_request.approvals.length > 0) {
          let approval = document.getElementById(this.task.approval_scroll_id)
          approval.scrollTop = approval.scrollHeight
        }

        // task
        if (this.task.task_status.id === 200) {
          let task = document.getElementById(this.task.task_scroll_id)
          task.scrollTop = task.scrollHeight
        }
      },
    
      formatContent (content) {
        if (content.includes('http')) {
          let urlRegex = /(https?:\/\/[^\s]+)/g
          return content.replace(urlRegex, function (url) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>'
          })  
        }
        return content
      },
    },
  }
</script>

<style scoped>
.task-details{
  background-color:#fbfbfb;
  border-radius:5px;
  padding:10px;
  width:100%
}

.task-content{
  border:1px solid #e6e6e6;
  border-radius:5px;
  padding:10px;
  min-height:100px;
  width:100%;
  text-align: justify;
  text-justify: inter-word;
  font-size:15px;
  color:#343434
}

.margin-auto{
  margin:auto
}

.file-display{
  min-height:70px;
  text-align:center;
  display:flex
}

.long-and-truncated {
  display: inline;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;/* Important for long words! */
}

.divider{
  border-left:1px solid #e6e6e6
}

.header{
  font-size:18px !important
}

.align-header-switch{
  display: flex;
  margin-top: 12px;
  height: 40px;
}

.approval-comment-content{
  max-height:505px;
  overflow-y:auto;
  min-height:505px
}

.comment-box-left{
  border:1px solid #e6e6e6;
  border-radius:5px;
  width:436px;
  margin-left:30px;
}

.comment-box-right{
  border:1px solid #e6e6e6;
  border-radius:5px;
  width:436px;
  margin-right:30px;
}

.justify-content{
  text-align: justify;
  text-justify: inter-word;
}

.align-right{
  text-align:right
}

.overflow{
  height:500px;
  overflow-y:auto;
}

.rating{
  height:30px
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.ellipsis-assignee{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 170px;
}

.content-pre-line{
  white-space: pre-line
}
</style>
